import { _APIRoutes } from './apiRoutes';

export { _APIRoutes as APIRoutes };
